import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { COURIER } from 'domains/customer-refund-shipment/constants'


const propTypes = {
  courier: PropTypes.string
}


/**
 * @param {string} courier
 */
const CustomerRefundShipmentCourierBadge = ({ courier }) => {

  const colorMap = {
    [COURIER.KGXPRESS]: 'primary'
  }

  const color = colorMap[courier] || 'default'

  return <StatusBadge color={ color } label={ courier } />
}

CustomerRefundShipmentCourierBadge.propTypes = propTypes

export default CustomerRefundShipmentCourierBadge
